import { FileDropZone } from './FileDropZone'
import { Button, Icon } from './ui'
import './shared.css'

/** Riquadro quadrato per un solo file: vuoto si clicca o si trascina, pieno mostra il nome e "Togli". */
export function FileTile({ label, file, status, onFile, onClear, disabled }: {
  label: string
  file: File | null
  status?: string
  onFile: (file: File) => void
  onClear: () => void
  disabled?: boolean
}) {
  if (!file) {
    return <FileDropZone square multiple={false} disabled={disabled ?? false} label={label}
      onFiles={files => { if (files[0]) onFile(files[0]) }} />
  }
  return (
    <div className="ecrm-filetile" title={file.name}>
      <Icon name="description" size={20} />
      <strong>{label}</strong>
      <span className="ecrm-filetile__name text-muted">{status ?? file.name}</span>
      <Button type="button" variant="text" size="sm" disabled={disabled} onClick={onClear}>Togli</Button>
    </div>
  )
}
